module.exports = __webpack_public_path__ + "img/Feature.34a37fea.png";